import React from 'react';
import { Trash2 } from 'lucide-react';

// Shown instead of a type-specific properties panel whenever more than one
// block is selected — type-specific properties don't make sense across
// mixed/multiple blocks, so this just surfaces the one action that still
// applies to the whole selection: delete.
export default function MultiSelectPanel({ count, onDelete }) {
  if (count <= 1) return null;

  return (
    <div className="ss-print__panel">
      <div className="ss-print__panel-header">
        <h3 className="ss-print__panel-title">{count} items selected</h3>
        <div className="ss-print__panel-header-actions">
          <button
            type="button"
            className="ss-print__lock-toggle ss-print__lock-toggle--danger"
            onClick={onDelete}
            aria-label="Delete selected blocks"
            title="Delete selected blocks"
          >
            <Trash2 size={16} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
